import React, { useEffect, useState, useCallback } from 'react';
import { load } from '@cashfreepayments/cashfree-js';
import { useSelector } from 'react-redux';
import { createPaymentSession } from '../api/APIService';
import Toast from './Toast';
import Loader from './Loader';

const Checkout = ({ onSuccess, onError, onComplete, userWallet }) => {
    const [cashfree, setCashfree] = useState(null);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
    const [errors, setErrors] = useState({});
    const [rechargeAmount, setRechargeAmount] = useState(0);
    const [paymentSession, setPaymentSession] = useState(null);

    const user = useSelector((state) => state.auth.user);

    const initializeSDK = useCallback(async () => {
        try {
            const cf = await load({ mode: 'production' });
            setCashfree(cf);
        } catch (error) {
            console.error('Failed to initialize Cashfree SDK:', error);
            setToast({ show: true, message: 'Payment gateway initialization failed', type: 'error' });
        }
    }, []);

    useEffect(() => {
        initializeSDK();
    }, [initializeSDK]);

    useEffect(() => {
        if (userWallet?.chargeAmount) {
            // setRechargeAmount(userWallet.chargeAmount * 2);
            setRechargeAmount(5);
        }
    }, [userWallet]);

    const doPayment = useCallback(async () => {
        if (!cashfree) {
            setToast({ show: true, message: 'Payment gateway not ready', type: 'error' });
            return;
        }

        if (!paymentSession?.payment_session_id) {
            setToast({ show: true, message: 'Payment session not found', type: 'error' });
            return;
        }

        const checkoutOptions = {
            paymentSessionId: paymentSession.payment_session_id,
            redirectTarget: '_modal',
        };

        try {
            const result = await cashfree.checkout(checkoutOptions);

            if (result.error) {
                setToast({ show: true, message: 'Payment failed or cancelled', type: 'error' });
                onError?.(result.error);
            } else if (result.paymentDetails) {
                setToast({ show: true, message: 'Payment completed successfully!', type: 'success' });
                onSuccess?.(result.paymentDetails);
            } else if (result.redirect) {
                setToast({ show: true, message: 'Payment redirected', type: 'info' });
            }
        } catch (error) {
            console.error('Payment error:', error);
            setToast({ show: true, message: 'Payment processing failed', type: 'error' });
            onError?.(error);
        } finally {
            setLoading(false);
            onComplete?.();
        }
    }, [cashfree, paymentSession, onSuccess, onError, onComplete]);

    const validateAmount = useCallback((value) => {
        const minAmount = 5;//userWallet?.chargeAmount * 2 || 0;
        if (!value || value < minAmount) {
            return `Please enter minimum ₹${minAmount}`;
        }
        return null;
    }, [userWallet]);

    const handleAmountChange = (value) => {
        setRechargeAmount(value);
        const error = validateAmount(value);
        setErrors({ rechargeAmount: error });
    };

    const initiateCashfreePayment = async () => {
        const amountError = validateAmount(rechargeAmount);
        if (amountError) {
            setToast({ show: true, message: amountError, type: 'error' });
            return;
        }

        if (!user?.mobileNumber) {
            setToast({ show: true, message: 'User information not available', type: 'error' });
            return;
        }

        setLoading(true);

        try {
            const response = await createPaymentSession({
                orderId: `${user.mobileNumber}_${Date.now()}`,
                amount: rechargeAmount,
                customerName: user.fullName || 'User',
                customerEmail: user.email || 'user@example.com',
                customerPhone: user.mobileNumber
            });

            console.log('Payment session response:', response.data);

            if (response.data?.payment_session_id) {
                setPaymentSession(response.data);

                // Wait for state update then proceed with payment
                setTimeout(() => {
                    processPayment(response.data);
                }, 100);
            } else {
                throw new Error('Invalid payment session response');
            }

        } catch (error) {
            console.error('Payment session creation failed:', error);
            setToast({ show: true, message: 'Failed to create payment session', type: 'error' });
            setLoading(false);
        }
    };

    const processPayment = async (sessionData) => {
        if (!cashfree) {
            setToast({ show: true, message: 'Payment gateway not ready', type: 'error' });
            setLoading(false);
            return;
        }

        const checkoutOptions = {
            paymentSessionId: sessionData.payment_session_id,
            redirectTarget: '_modal',
        };

        try {
            const result = await cashfree.checkout(checkoutOptions);

            if (result.error) {
                setToast({ show: true, message: 'Payment failed or cancelled', type: 'error' });
                onError?.(result.error);
            } else if (result.paymentDetails) {
                setToast({ show: true, message: 'Payment completed successfully!', type: 'success' });
                onSuccess?.(result.paymentDetails);
            } else if (result.redirect) {
                setToast({ show: true, message: 'Payment redirected', type: 'info' });
            }
        } catch (error) {
            console.error('Payment error:', error);
            setToast({ show: true, message: 'Payment processing failed', type: 'error' });
            onError?.(error);
        } finally {
            setLoading(false);
            onComplete?.();
        }
    };

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-center mb-4">Recharge Wallet</h5>
{/* <h5 style={{backgroundColor : 'red'}}>तांत्रिक अडचणीमुळे रिचार्ज सेवा बंद आहे</h5>
 */}                            <div className="mb-3">
                                <label className="form-label">Amount</label>
                                <input
                                    type="number"
                                    className={`form-control ${errors.rechargeAmount ? 'is-invalid' : ''}`}
                                    placeholder="Enter amount"
                                    value={rechargeAmount}
                                    onChange={(e) => handleAmountChange(e.target.value)}
                                    min={userWallet?.chargeAmount * 2 || 0}
                                />
                                {errors.rechargeAmount && (
                                    <div className="invalid-feedback">{errors.rechargeAmount}</div>
                                )}
                            </div>

                            <button
                                className="btn btn-teal w-100"
                                onClick={initiateCashfreePayment}
                                disabled={loading || !!errors.rechargeAmount || !cashfree}
                            >
                                {loading ? 'Processing...' : `Pay ₹${rechargeAmount}`}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <Loader show={loading} />
        </div>
    );
};

export default Checkout;